"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRgb = exports.rgbToHex = exports.toRgb = exports.toHex = exports.isDark = exports.isLight = void 0;
var tinycolor = require('tinycolor2');
var isLight = function (color) { return tinycolor(color).isLight(); };
exports.isLight = isLight;
var isDark = function (color) { return tinycolor(color).isDark(); };
exports.isDark = isDark;
var toHex = function (color) { return tinycolor(color).toHexString(); };
exports.toHex = toHex;
var toRgb = function (color) { return tinycolor(color).toRgbString(); };
exports.toRgb = toRgb;
exports.rgbToHex = exports.toHex;
exports.hexToRgb = exports.toRgb;
//# sourceMappingURL=color-utils.js.map